import React from 'react'
import styled from 'styled-components'

export function RowTypeSpaceBetween({children,...rest}){
  return (
    <Row2 {...rest}>
      {children}
    </Row2>
  )
}
const Row2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export function ColumnTypeSimple({children,...rest}){
  return (
    <Column1 {...rest}>
      {children}
    </Column1>
  )
}

const Column1 = styled.div`
  display: flex;
  flex-direction: column;
`;